import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import SearchAssignee from "../../../components/AssigneeSearch";
import { useDataMutation } from "../../../hooks/useDataModule";
import { User } from "../../../models/generated/graphql";
import { userOrganization } from "../../../store/layout";
import { userPersonalInfoState } from "../../../store/user";
import startUpper from "../../../utils/start-upper";
import { GET_CASE_BY_ID, GET_USERS, UPDATE_CASE_ASSIGNEE } from "../queries";
import { makeStyles } from "@material-ui/core";

interface CaseAssigneeProps {
	caseId: string | undefined;
	assignedTo?: User[] | null;
}

const CaseAssignee: React.FC<CaseAssigneeProps> = ({ caseId, assignedTo }) => {
	const [mutate, { loading, error }] = useDataMutation(UPDATE_CASE_ASSIGNEE, {
		refetchQueries: [{ query: GET_CASE_BY_ID, variables: { id: caseId } }],
	});
	const user = useRecoilValue(userPersonalInfoState);
	const { t } = useTranslation();
	const userOrg = useRecoilValue(userOrganization);
	const notSameTenantIdAsCreator =
		assignedTo !== null && assignedTo!.length > 0 && assignedTo![0].tenantId !== user.organization.externalId;
	const label = `${startUpper(t("assignee"))} ${userOrg.name || ""}`;
	const handleUpdateAssignee = (users: Array<User | undefined>) => {
		mutate({
			variables: {
				input: {
					caseId,
					assignees: users
						.filter((us) => us)
						.map((tempUser) => {
							return { email: tempUser!.email, userId: tempUser!.id };
						}),
				},
			},
		});
	};

	if (error) {
		console.error(error);
	}

	return (
		<SearchAssignee
			isDisabled={loading || notSameTenantIdAsCreator}
			selectedUsers={assignedTo}
			handleUpdateAssignee={handleUpdateAssignee}
			query={GET_USERS}
			operationVariables={{ variables: { caseId } }}
			usersType="GetAvailableCaseAssignees"
			label={label}
		/>
	);
};

export default CaseAssignee;
